<template>
  <div class="nav-bar">
    <div :class="['dot', index === 0 ? 'dot-selected' : '']"></div>
    <div :class="['dot', index === 1 ? 'dot-selected' : '']"></div>
    <div :class="['dot', index === 2 ? 'dot-selected' : '']"></div>
    <div :class="['dot', index === 3 ? 'dot-selected' : '']"></div>
  </div>
</template>

<script>
// @ is an alias to /src
// import Idle from "@/views/Idle.vue";

export default {
  name: "nav_bar",
  props: { index: Number },
  components: {},
  data() {
    return {};
  },
  computed: {},
  methods: {},
  mounted() {},
  beforeDestroy() {}
};
</script>

<style lang="scss" scoped>
.nav-bar {
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: row;
  transition: background-color 0.5s linear;
}

.dot {
  width: 15px;
  height: 15px;
  border-radius: 50%;
  background-color: rgba(0, 176, 240, 0.5);
  margin: 5px; /* and that, will result in a 10px gap */
}

.dot-selected {
  background-color: rgba(0, 176, 240, 1);
}
</style>